
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.949.04C2.756.04.959 1.832.959 4.02c0 1.353.69 2.552 1.732 3.272-.61.26-1.115.622-1.5 1.06C.384 9.267 0 10.529 0 11.94v3.716l.527.215a1.2 1.2 0 00.457.09h7.93a1.2 1.2 0 00.457-.09l.527-.215V11.94c0-1.41-.384-2.673-1.19-3.589a4.15 4.15 0 00-1.501-1.06 3.979 3.979 0 001.732-3.27c0-2.189-1.797-3.98-3.99-3.98zm0 1.706c1.27 0 2.28 1.008 2.28 2.274a2.264 2.264 0 01-2.28 2.275 2.264 2.264 0 01-2.28-2.275 2.264 2.264 0 012.28-2.274zm0 6.823c1.32 0 2.018.392 2.474.908.466.53.765 1.362.765 2.463v2.315H1.71V11.94c0-1.101.299-1.934.765-2.463.456-.516 1.153-.908 2.474-.908z","font-family":"sans-serif","overflow":"visible"}}),_c('path',{attrs:{"d":"M15.251 4.53a.678.678 0 00-.456.248l-2.996 3.714-1.715-1.744a.678.678 0 00-.959-.01.678.678 0 00-.009.96l2.25 2.287a.678.678 0 001.012-.05l3.472-4.307a.678.678 0 00-.102-.952.678.678 0 00-.497-.146z"}})])
          )
        }
      }
    